import type { UseFormReturn } from 'react-hook-form';

import { FormCheckbox, FormField, FormInput, Label } from '@/_components';

import type { PaymentMethodFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<PaymentMethodFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12"
            label="Payment Method (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <FormField
          control={form.control}
          name="include_for_taking_tender"
          render={({ field }) => (
            <div className="pb-1.5">
              <Label className="mb-1.5 -translate-y-2 text-[11px]">Include for taking Tender</Label>
              <FormCheckbox
                disabled={!isEditable}
                checked={field.value}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                }}
                label={'Include'}
              />
            </div>
          )}
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <FormField
          control={form.control}
          name="include_for_manual_deposit"
          render={({ field }) => (
            <div className="pb-1.5">
              <Label className="mb-1.5 -translate-y-2 text-[11px]">Include for manual deposit</Label>
              <FormCheckbox
                disabled={!isEditable}
                checked={field.value}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                }}
                label={'Include'}
              />
            </div>
          )}
        />
      </div>

      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <FormField
          control={form.control}
          name="is_active"
          render={({ field }) => (
            <div className="pb-1.5">
              <Label className="mb-1.5 -translate-y-2 text-[11px]">Status</Label>
              <FormCheckbox
                disabled={!isEditable}
                checked={field.value}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                }}
                label={'Active'}
              />
            </div>
          )}
        />
      </div>
    </>
  );
}
